import { ClassInstitution } from '@/globalInterfaces/Classe';

interface State {
  classIdSelected: ClassInstitution | null;
}
const Classe = {
  namespaced: true,
  state: {
    classIdSelected: null as ClassInstitution | null
  } as State,
  mutations: {
    setInstitutionClassIdSelected(
      state: { classIdSelected: ClassInstitution | null },
      classIdSelected: ClassInstitution | null
    ) {
      state.classIdSelected = classIdSelected;
    }
  },
  getters: {
    classIdSelected: (state: State) => state.classIdSelected
  }
};

export default Classe;
